import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LangProvider } from "./contexts/LangContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Booking from "./pages/Booking";
import BookingSuccess from "./pages/BookingSuccess";
import AdminDashboard from "./pages/AdminDashboard";
import AuthCallback from "./pages/AuthCallback";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import CityPage from "./pages/CityPage";
import LoyaltyPage from "./pages/LoyaltyPage";
import B2BPage from "./pages/B2BPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import TrackBooking from "./pages/TrackBooking";
import GraffitiEntfernungHamburg from "./pages/GraffitiEntfernungHamburg";
import ZweimannHandling from "./pages/ZweimannHandling";
import KuechenMontage from "./pages/KuechenMontage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import WhatsAppButton from "./components/WhatsAppButton";
import CustomCursor from "./components/CustomCursor";
import LiveActivity from "./components/LiveActivity";
import PWAInstallBanner from "./components/PWAInstallBanner";
import ChatWidget from "./components/ChatWidget";
import ExitIntentPopup from "./components/ExitIntentPopup";
import StickyCTABar from "./components/StickyCTABar";
import MobileCallButton from "./components/MobileCallButton";
import CookieConsent from "./components/CookieConsent";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: detect session_id during render (NOT in useEffect)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const hideChatWidget = location.pathname.startsWith("/admin");
  return (
    <>
      <CustomCursor />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/book" element={<Booking />} />
          <Route path="/booking/success" element={<BookingSuccess />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/standort/:slug" element={<CityPage />} />
          <Route path="/loyalty" element={<LoyaltyPage />} />
          <Route path="/b2b" element={<B2BPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/track" element={<TrackBooking />} />
          <Route path="/leistungen/graffiti-entfernung-hamburg" element={<GraffitiEntfernungHamburg />} />
          <Route path="/leistungen/2-mann-handling-hamburg" element={<ZweimannHandling />} />
          <Route path="/2-mann-handling" element={<ZweimannHandling />} />
          <Route path="/leistungen/kuechenmontage-hamburg" element={<KuechenMontage />} />
          <Route path="/kuechenmontage" element={<KuechenMontage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/referenzen" element={<CaseStudiesPage />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
      {!hideChatWidget && <ChatWidget />}
      <LiveActivity />
      <PWAInstallBanner />
      <ExitIntentPopup />
      <StickyCTABar />
      <MobileCallButton />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <LangProvider>
            <AuthProvider>
              <Toaster position="top-right" richColors />
              <AppRouter />
            </AuthProvider>
          </LangProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
